import { call, put, takeLatest } from 'redux-saga/effects';
import { ACTIONS_TYPES } from "../utils/constants";
import {getJobAudits } from '../utils/requests';
import { getJobAuditsSuccess, getJobAuditsFailed, getJobAuditsRequest} from '../actions/audit';

export function* getJobAuditsWatcherSaga() {
  yield takeLatest(ACTIONS_TYPES.GET_JOB_AUDITS_REQUEST, getJobAuditsRequestWatcher);
}

function* getJobAuditsRequestWatcher(action) {
  try {
    const { payload } = action;
    const response = yield call(getJobAudits, payload);
    yield put(getJobAuditsSuccess(response.data));
  } catch(error) {
    let errorPayload = {};
    if (error.response) {
      errorPayload = error.response.data;
    }
    yield put(getJobAuditsFailed(errorPayload));
  }
  
}